import React from 'react';
import { Grid, ShimmerImage } from '@pitchero/react-ui';

const AlbumLoadingState = () => (
  <Grid
    preset="gallery"
    style={{
      gridAutoFlow: 'row-dense',
    }}
  >
    <ShimmerImage
      style={{ gridColumn: 'span 2', overflow: 'hidden' }}
      preset="photoSquare"
      fullWidth
    />
    <ShimmerImage
      style={{ gridColumn: 'span 2', overflow: 'hidden' }}
      preset="photoSquare"
      fullWidth
    />
    <ShimmerImage
      style={{ gridColumn: 'span 2', overflow: 'hidden' }}
      preset="photoSquare"
      fullWidth
    />
    <ShimmerImage
      style={{ gridColumn: 'span 3', overflow: 'hidden' }}
      preset="photoLandscape"
      fullWidth
    />
    <ShimmerImage
      style={{ gridColumn: 'span 3', overflow: 'hidden' }}
      preset="photoLandscape"
      fullWidth
    />
    <ShimmerImage
      style={{ gridColumn: 'span 3', overflow: 'hidden' }}
      preset="photoLandscape"
      fullWidth
    />
    <ShimmerImage
      style={{ gridColumn: 'span 3', overflow: 'hidden' }}
      preset="photoLandscape"
      fullWidth
    />
    <ShimmerImage
      style={{ gridColumn: 'span 2', overflow: 'hidden' }}
      preset="photoPortrait"
      fullWidth
    />
    <ShimmerImage
      style={{ gridColumn: 'span 2', overflow: 'hidden' }}
      preset="photoPortrait"
      fullWidth
    />
    <ShimmerImage
      style={{ gridColumn: 'span 2', overflow: 'hidden' }}
      preset="photoSquare"
      fullWidth
    />
    <ShimmerImage
      style={{ gridColumn: 'span 2', overflow: 'hidden' }}
      preset="photoSquare"
      fullWidth
    />
    <ShimmerImage
      style={{ gridColumn: 'span 2', overflow: 'hidden' }}
      preset="photoSquare"
      fullWidth
    />
    <ShimmerImage
      style={{ gridColumn: 'span 2', overflow: 'hidden' }}
      preset="photoSquare"
      fullWidth
    />
    <ShimmerImage
      style={{ gridColumn: 'span 2', overflow: 'hidden' }}
      preset="photoPortrait"
      fullWidth
    />
    <ShimmerImage
      style={{ gridColumn: 'span 2', overflow: 'hidden' }}
      preset="photoPortrait"
      fullWidth
    />
  </Grid>
);

export default AlbumLoadingState;
